/** Randare compactă a unui obiect JSONB (details) ca perechi „cheie: valoare”. */
export function detailsText(details: Record<string, unknown> | null | undefined): string {
  if (!details) return '';
  return Object.entries(details)
    .filter(([, v]) => v !== null && v !== undefined && v !== '')
    .map(([k, v]) => `${k}: ${typeof v === 'object' ? JSON.stringify(v) : String(v)}`)
    .join(' · ');
}
